// 图片身份使用相对路径，展示 URL 单独保留，避免删图或换序时串用配置。
export function templatePath(url) {
    const index = typeof url === 'string' ? url.indexOf('/uploads/') : -1;
    if (index < 0) throw new Error('邀请函图片无法使用，请重新上传');
    return url.slice(index);
}

export function copy(value) {
    return JSON.parse(JSON.stringify(value));
}

export function legacyConfig(path) {
    return { templatePath: path, mode: 'legacy' };
}

export function regionConfig(path, width = 1080, height = 1920) {
    return {
        templatePath: path,
        mode: 'region',
        templateSize: { width, height },
        enabled: true,
        previewName: '欧阳明月',
        nameRegion: {
            x: Math.round(width * 0.1), y: Math.round(height * 0.6),
            width: Math.round(width * 0.8), height: Math.round(height * 0.1)
        },
        textStyle: {
            fontKey: 'activity_default', maxFontSize: 94, minFontSize: 8,
            color: '#163253', horizontalAlign: 'center', verticalAlign: 'center',
            autoShrink: true, padding: 10
        }
    };
}

/** 校验在三个保存入口共同执行；不把历史 legacy 图自动迁移。 */
export function validateInvitation(items, layout, { draft, supported, requiresComplete, savedPaths, requirePreviewName = false }) {
    if (!Array.isArray(items) || items.length > 3 || !layout || layout.version !== 1 || !Array.isArray(layout.templates)) {
        throw new Error('邀请函设置未成功加载，请刷新后重试');
    }
    const paths = items.map(item => templatePath(item.url));
    if (new Set(paths).size !== paths.length || layout.templates.length !== paths.length) throw new Error('邀请函图片重复或设置不完整，请重新检查');
    paths.forEach((path, index) => {
        const config = layout.templates.find(item => item.templatePath === path);
        if (!config || !['legacy', 'region'].includes(config.mode)) throw new Error(`请重新设置第${index + 1}张邀请函`);
        if (!supported && config.mode === 'region') throw new Error('当前活动的邀请函使用固定样式，暂不支持调整姓名区域');
        if (!draft && supported && (requiresComplete || !savedPaths.includes(path)) && config.mode !== 'region') {
            throw new Error(`请先设置第${index + 1}张邀请函的姓名区域`);
        }
        if (config.mode === 'region') {
            const r = config.nameRegion;
            const size = config.templateSize;
            const style = config.textStyle;
            if (!size || typeof config.enabled !== 'boolean' || !style || typeof config.previewName !== 'string'
                || Array.from(config.previewName).length > 100 || Array.from(config.previewName).some(character => {
                    const code = character.charCodeAt(0);
                    return code < 32 || code === 127 || code === 0x2028 || code === 0x2029;
                })) {
                throw new Error(`第${index + 1}张邀请函设置不完整，请检查后重试`);
            }
            if (config.enabled && !r) throw new Error(`请框选第${index + 1}张邀请函的姓名区域`);
            if (requirePreviewName && config.enabled && !config.previewName.trim()) throw new Error(`请填写第${index + 1}张邀请函的测试姓名`);
            if (r && (!['x', 'y', 'width', 'height'].every(key => Number.isInteger(r[key]))
                || r.x < 0 || r.y < 0 || r.width < 40 || r.height < 40
                || r.x + r.width > size.width || r.y + r.height > size.height)) {
                throw new Error(`第${index + 1}张邀请函的姓名区域超出原图范围`);
            }
            if (!Number.isInteger(style.maxFontSize) || style.maxFontSize < 12 || style.maxFontSize > 300
                || !/^#[a-f\d]{6}$/i.test(style.color)) throw new Error(`第${index + 1}张邀请函的字号或颜色不正确`);
        }
    });
}
